import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import axios from "axios";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
function Items({ currentItems ,balanceCoin,varizchange,bardashtchange,coinchange,coinbchange,FavoriteCoins,setFavoriteCoins}) {

    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()
    const [coinSelected,setCoinSelected] = useState('')
    const [varizIsOpen,setVarizIsOpen] = useState(false)
    const [bardashtIsOpen,setBardashtIsOpen] = useState(false)
    const [favoritList,setFavoritList] = useState(FavoriteCoins)

    useEffect(()=>{








        axios.get('https://api.sinatether.com/Auth/get_favorite_list').then((res)=>{


            if(res.status == 200){


                setFavoritList(res.data['list_favorite'])
            }
             
  
  
        })
      },[])

    
      function handleTofavorite(event){

        let name = event.target.id

        axios.post('https://api.sinatether.com/Auth/add_to_favorite',{"coin":name}).then((res)=>{


        if (res.data['status'] == "200"){

            setFavoritList(res.data['list'])
            setFavoriteCoins(res.data['list'])
            toast.success(res.data['message'],
            {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                })
        }



        })



    }

    function handelvariz(event) {
        coinchange(event.target.value)
         varizchange(true)
     }

     function handelbardasht(event){
        coinbchange(event.target.value)
        bardashtchange(true)
     }


     



    useEffect(async()=>{
        axios.get('https://api.sinatether.com/Auth/GetTeter').then((res)=>{

            if (res.status==200){
                 setTeterPriceBuy(res.data['teterprice']['buy'])
                 setTeterPriceSell(res.data['teterprice']['sell'])

            }

       })
    },[])

    return (
        <>
    {currentItems && currentItems.map((sym) => (




            
                                      
<div className={'row tr_row   px-1 '}>
<div className={'col-2 mt-2 d-flex'}>
<img className='heart-style' id={sym['symbol'].split('-')[0]} src={`https://static.sinatether.com/images/${favoritList.includes(sym['symbol'].split('-')[0]) ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />

                          <Link className="pointer linkStyle" to={`/${sym['symbol'].split('-')[0]}`}>
                              <div className="text-black">
                                  <img className="imgcoin "
                                      src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                  <i className="fa-solid fa-square-up-right"></i>
                                  <span
                                      className="spanHeaderAcc">
                      <span
                      className="ft-external-link text-large">{sym['persionName']}


      <span className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>

                      
                      
                      
                      </span>

                      </span>

                              </div>
                          </Link>


                      </div>
                      {sym ?
                          <>

                      <div className={'col-2 '}>

                                  <div className={'mt-3 table-hover'}>
                                      <p className={'mt-2 text-success'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:sym['BuyIrt'] > 1 ? 3 : 13}).format(sym['BuyIrt'])} </p>
                                  </div>

                              </div>
                              <div className="col-2">
                                  <div className={'mt-3 table-hover'}>
                                      <p className={'mt-2 text-danger'}> {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sellIrt'] > 1 ? 3 : 13}).format(sym['sellIrt'])} </p>
                                  </div>
                              </div>
                              <div className="col-1">
                                  <div className={'mt-3 table-hover pl-4'}>
                                      <p className={'mt-2 priceTt'}> {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sell'] > 1 ? 3 : 13}).format(sym['sell'])}</p>
                                  </div>
                              </div>


                          </>
                          :
                          <>


                             

                          </>


                      }
                  <div className={'col-2 text-center '}>

                          {balanceCoin[sym['symbol'].split('-')[0]] ?

                          <div className={'text-large text-dark pl-4 mt-3'}>
                              <p className={'text-dark mt-2'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balanceCoin[sym['symbol'].split('-')[0]])}</p>
                          </div>

                              :

                          <p className={'text-large text-dark pl-4 mt-3'}>
                              <span className={'text-dark mt-2'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(0)}</span>
                          </p>

                          }
                      </div>



                      <div className={'col-3'}>

                          <div className="rowButton float-left text-right mt085 px-3 ">
                              <div className="col-3 px-1 px---1">
                              <Link to={`/${sym['symbol'].split('-')[0]}`}>
                                  <button
                                      className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                  </button>
                                  </Link>
                              </div>
                              <div className="col-3 px-1 px---1">
                              <Link to={`/${sym['symbol'].split('-')[0]}`}>
                                  <button
                                      className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                  </button>
                                  </Link>
                              </div>
                              <div className="col-3 px-1 px---1">
                                  <button
                                      className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-success"
                                      value={sym['symbol'].split('-')[0]}
                                      onClick={handelvariz}>واریز
                                  </button>
                              </div>
                              <div className="col-3 px-1 px---1">
                                  <button
                                      className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-danger text-danger mr-3"
                                      value={sym['symbol'].split('-')[0]}
                                      onClick={handelbardasht}>برداشت
                                  </button>
                              </div>
                          </div>


                      </div>

                      </div>





        )

    )
}
        </>
    )}


export default function PageItemsDash({key, itemsPerPage ,items,balanceCoin,varizchange,bardashtchange,coinchange,coinbchange,FavoriteCoins,setFavoriteCoins}) {
  // We start with an empty list of items.

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % items.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items currentItems={currentItems} balanceCoin={balanceCoin} varizchange={varizchange} bardashtchange={bardashtchange} coinchange={coinchange} coinbchange={coinbchange} FavoriteCoins={FavoriteCoins} setFavoriteCoins={setFavoriteCoins}/>
      <ReactPaginate
        nextLabel = {<img src='./icons/left.svg'/>}
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel={<img src='./icons/right.svg'/>}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />    </>
  );
}